<sb-card>
  <div card-header>
    Playlist
    @if (sharedPlaylists?.length > 1) {
      {{ currentPlaylist }}
    }
  </div>
  <div card-header-more class="d-flex">
    <button (click)="showPreview(currentPlaylist)" [disabled]="checkDisabled(currentPlaylist)"
            class="btn btn-success mr-4">
      <sb-icon icon="lightbox"></sb-icon>
      {{ 'lang.globals.preview' | translate }}
    </button>
    <div class="d-flex align-items-center">
      @if (sharedPlaylists?.length > 1) {
        <sb-icon (click)="e?.prev()" class="mx-1 cursor-pointer blue" icon="arrowLeftAlt">
        </sb-icon>
        {{ currentPlaylist }} {{ 'lang.globals.of' | translate }} {{ sharedPlaylists?.length }}
        <sb-icon (click)="e?.next()" class="mx-1 cursor-pointer blue" icon="arrowRightAlt">
        </sb-icon>
      }
    </div>
  </div>
  <div card-body>

    <ngb-carousel #e (slide)="currentPlaylist = $event.current" [activeId]="currentPlaylist" [interval]="-1" [keyboard]="false"
                  [showNavigationArrows]="false" [showNavigationIndicators]="false" [wrap]="true">
      <ng-template *ngFor="let sharedPlaylist of sharedPlaylists; index as i" id="{{i+1}}" ngbSlide>
        <div *ngIf="currentPlaylist === (i+1).toString()" class="row">
          <div class="col-3">
            <h3>
              Info
            </h3>
            <div class="d-flex flex-row mb-3 mr-2">
              <div class="d-flex flex-column justify-content-start">
                <div class="m-3 d-flex" *ngIf="sharedPlaylist?.playlist?.schedule">
                  <sb-icon class="mr-2" icon="schedules"></sb-icon>
                  {{ 'lang.schedules.schedule'|translate }}:
                  {{ sharedPlaylist?.playlist?.schedule?.name }}
                </div>
                <div [ngClass]="{ 'pe-none': isInDeviceContext}" class="m-3 d-flex">
                  <a (click)="showScreensModal(sharedPlaylist?.screens)">
                    <sb-icon class="mr-2" icon="screen"></sb-icon>
                    {{ 'lang.globals.screens'|translate }}:
                    {{ sharedPlaylist?.screens?.length }}
                  </a>
                </div>
                <div class="m-3 d-flex">
                  <sb-icon class="mr-2" icon="slot"></sb-icon>
                  {{ 'lang.globals.slots'|translate }}:
                  {{ sharedPlaylist?.playlist?.slotCount }}
                </div>
                <div class="m-3 d-flex">
                  <a (click)="showDateTimeRanges(sharedPlaylist?.ranges)">
                    <sb-icon class="mr-2" icon="calendar"></sb-icon>
                    {{ 'lang.globals.timeRanges'|translate }}:
                    {{ sharedPlaylist?.ranges?.length }}
                  </a>
                </div>
              </div>
            </div>
            <div class="d-flex mt-2 flex-column justify-content-start">
              <div *ngFor="let range of sharedPlaylist?.ranges" class="d-flex my-1 mx-3 border-dashed-bottom"
                   container="body"
                   [ngbTooltip]="util.calculateTimespanBetweenDates(range?.from, range?.till)"
              >
                {{ util.dateToDateTimeString(range?.from?.value) }}  -  {{ util.dateToDateTimeString(range?.till?.value) }}
              </div>
            </div>
          </div>
          <div class="col-9">
            <ng-container *ngIf="aggregated">

              <sb-comp-aggregated-playlist-schema [playlist]="sharedPlaylist?.playlist"></sb-comp-aggregated-playlist-schema>
            </ng-container>
            <ng-container *ngIf="!aggregated">
              <sb-comp-playlist-schema [playlist]="sharedPlaylist?.playlist"></sb-comp-playlist-schema>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</sb-card>
